import { compact } from 'lodash-es'
import type { ComboboxAsyncOption } from '#src/components/core/combobox/ComboboxAsync.tsx'

export interface ValueSetAutocompleteValue {
  code: string
  display: string
  system: string
}

export function defaultToOption(
  element: ValueSetAutocompleteValue
): ComboboxAsyncOption<ValueSetAutocompleteValue> {
  return {
    value: element,
    label: element.display,
    keywords: compact([element.code, element.display]),
  }
}
